import { useEffect, useState } from 'react';
import { getAppVersion } from 'AppVersion';

type BuildInfoResponse = {
    buildDate?: string;
};

const formatBuildDate = (rawDate?: string): string => {
    if (!rawDate) {
        return '0.0.1';
    }

    const dateObj = new Date(rawDate);
    if (Number.isNaN(dateObj.getTime())) {
        return rawDate;
    }

    const year = dateObj.getFullYear().toString().slice(-2);
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const hour = dateObj.getHours().toString().padStart(2, '0');
    const minute = dateObj.getMinutes().toString().padStart(2, '0');

    return `${year}${month}${day}-${hour}.${minute}`;
};

export const useBuildInfoVersion = () => {
    const [buildDate, setBuildDate] = useState('0.0.1');
    const [appVersion, setAppVersion] = useState('...');

    useEffect(() => {
        let isMounted = true;

        const loadBuildInfo = async () => {
            try {
                const response = await fetch('/build-info.json');
                const data = (await response.json()) as BuildInfoResponse;
                if (!isMounted) {
                    return;
                }
                setBuildDate(formatBuildDate(data.buildDate));
            } catch (error) {
                console.error('Error loading build date:', error);
                if (!isMounted) {
                    return;
                }
                setBuildDate('0.0.1');
            }
        };

        loadBuildInfo();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadVersion = async () => {
            const version = await getAppVersion();
            if (!isMounted) {
                return;
            }
            setAppVersion(version ?? 'unknown');
        };

        loadVersion();

        return () => {
            isMounted = false;
        };
    }, []);

    return {
        buildDate,
        appVersion,
    };
};
